import { Injector, Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '../helper';

@Pipe({
  standalone: true,
  name: 'numberFormat',
})
export class NumberFormatPipe implements PipeTransform {
  constructor(private injector: Injector ) {}
  transform(number: number | string , format : boolean = true , translateNumbers : boolean = false): string {
    if (typeof number == 'string' || typeof number == 'number') {
      if (isNaN(Number(number))) {
        throw new Error('Not A Number Value');
      } else {
        return formatNumber(Number(number), this.injector , format , translateNumbers);
      }
    } else {
      return `${number}`;
    }
  }
}
